export const locale = {
  en: "en",
  "zh-cn": "zh-cn",
};
